export const campIndicatorHintKeys: Record<number, string> = {
  0: "barracks:camp.indicator.hints.0",
  100000: "barracks:camp.indicator.hints.100000",
  300000: "barracks:camp.indicator.hints.300000",
  900000: "barracks:camp.indicator.hints.900000",
  2700000: "barracks:camp.indicator.hints.2700000",
  8100000: "barracks:camp.indicator.hints.8100000",
};
